export default {

    data() {
        return {
            sessionActive: true
        }
    },

    mounted() {

        if (!Spark.session.auth) {

            this.sessionActive = false;

            // Close all components for show!
            Bus.$emit('navigation-drawer', false);
            Bus.$emit('chat-drawer', false);
            Bus.$emit('toolbar', false);

            this.$router.push('/spa/sessionexpired');
        }
    }
};

